import React, { ForwardedRef } from "react";
import ReactDatePicker, { ReactDatePickerProps } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useI18n } from "@/hooks/useI18n";
import { useAuthenticated } from "@gettactic/hooks";
import { cva } from "class-variance-authority";
import { inputV2Classes } from "@/components/reserve/utils/classes";

const datePickerVariants = cva(
  "mt-1 block w-full rounded-md border-gray-300 px-4 py-3 font-bold text-secondary text-sm placeholder-blue-800 focus:border-primary focus:outline-none focus:ring-primary [.tactic-v2_&]:text-secondary-foreground",
  {
    variants: {
      variant: {
        default: "",
        v2: inputV2Classes
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);

export const DatePicker = React.forwardRef(
  (
    props: ReactDatePickerProps & { variant?: "default" | "v2" },
    ref: ForwardedRef<ReactDatePicker>
  ) => {
    const {
      userContext: { authenticatedUser }
    } = useAuthenticated();
    const { templates } = useI18n(authenticatedUser);
    const dateFormat = props.dateFormat ?? templates.displayDate;
    return (
      <ReactDatePicker
        ref={ref}
        dateFormat={dateFormat}
        calendarStartDay={1}
        className={datePickerVariants({
          variant: props.variant,
          className: props.className
        })}
        {...props}
        formatWeekDay={(nameOfDay) => nameOfDay.substring(0, 1)}
        portalId={"root-portal"}
        popperClassName={"root-portal-date-picker-popper"}
        popperProps={{
          strategy: "fixed"
        }}
      />
    );
  }
);
export default DatePicker;
